// import React from 'react'; // You might need this import
import { Box, Card, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";  

export const printReport = (componentRef, pageTitle) => {
  const printWindow = window.open(
    "#/print_report",
    "_blank",
    "toolbar=0,location=0,menubar=0,rel=noreferrer"
  );
  printWindow.reportBody = componentRef.current.innerHTML;
  printWindow.reportTitle = pageTitle;
};

export const PrintDocument = () => {
  const tittle = window.reportTitle;
  const body = window.reportBody;
  const storedToken = localStorage.getItem("userData");

  // If you want to parse it back to an object
  const userData = storedToken ? JSON.parse(storedToken) : null;

  useEffect(() => {
    // Set the event handler to close the window after printing or canceling
    // The onafterprint event fires when the print dialog is closed.
    window.onafterprint = () => {
      console.log("Print dialog closed, closing window."); // Optional: for debugging
      window.close();
    };

    // Use a timeout to allow the HTML content to be parsed and rendered
    // into the DOM of the new window before calling print().
    const timer = setTimeout(() => {
      try {
        console.log("Calling window.print()"); // Optional: for debugging
        window.print();
      } catch (error) {
        console.error("Error calling window.print():", error);
        // Fallback or error handling if print() fails
        // The onafterprint handler should still attempt to close the window
        // even if print() failed to open the dialog, but it might not always fire.
      }
    }, 100); // Small delay to allow DOM to update. Adjust if needed.

    // Cleanup function: Clear the timeout and potentially the event handler
    // if the component were to unmount before the timeout or print finishes
    // (Less likely in a print window, but good practice)
    return () => {
      clearTimeout(timer);
      // It's generally not necessary to unset onafterprint here because
      // the window is intended to close anyway, but you could set it to null if needed.
      // window.onafterprint = null;
    };
  }, [body]); // Dependency array: runs when the component mounts and if body changes (though body should be static here)

  // The JSX renders the structure that window.print() will use
  return (
    <Card
      sx={{
        background: "white",
        color: "black",
        minHeight: "100vh",
        borderRadius: "1px",
      }}
      className="printDocument" // This class might be used for print CSS
    >
      <Box
        sx={{
          margin: "20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* Add checks for userData and school property existence */}
          {userData?.school?.school_prefix && (
            <img
              alt="School logo"
              src={`https://mzazilink.com/school_logos/${userData.school.school_prefix}.png`}
              style={{ marginRight: "10px", maxHeight: "60px" }} // Basic styling
            />
          )}
          <Box>
            <Typography variant="h3">
              {userData?.school?.school_name}
            </Typography>
            <Typography variant="body2">
              {userData?.school?.postal_address}
            </Typography>
          </Box>
        </Box>
        <Stack>
          <Typography
            sx={{
              textAlign: "center",
              textTransform: "uppercase",
              textDecoration: "underline",
              mt: 2, // Add some margin top
            }}
            variant="h5"
          >
            {tittle}
          </Typography>
        </Stack>
      </Box>
      {/* This Box will contain the table HTML from the original window */}
      {/* Use a key to ensure the Box re-renders if body changes, although not expected here */}
      <Box
        key={body} // Adding a key can sometimes help with dangerouslySetInnerHTML updates
        sx={{ minWidth: 800, margin: "0 20px 20px 20px" }} // Add margins for content
        dangerouslySetInnerHTML={{ __html: body }}
      ></Box>
    </Card>
  );
};
